import script from "./software-disabled.vue?vue&type=script&lang=ts&setup=true"
export * from "./software-disabled.vue?vue&type=script&lang=ts&setup=true"

import "./software-disabled.vue?vue&type=style&index=0&id=5ee53447&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ee53447"]])

export default __exports__